/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// React
import React, { useState, useEffect } from "react";

// Zaim engineering components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { useNavigate } from "react-router-dom";

export default function buildOrderTable(data, onEdit) {
  const Client = ({ name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const columns = [
    { Header: "Client", accessor: "client", width: "45%", align: "left" },
    { Header: "quoted By", accessor: "quotedBy", align: "center" },
    { Header: "grand total", accessor: "grandTotal", align: "center" },
    { Header: "status", accessor: "status", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = data.map((item) => {
    const statusColor = item.status === "Delivered" ? "success" : "warning";
    return {
      client: <Client name={item.customer.name} email={item.customer.email} />,
      quotedBy: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.user.name}
        </MDTypography>
      ),
      grandTotal: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          ₹{item.grandTotal}
        </MDTypography>
      ),
      status: (
        <MDBox ml={-1}>
          <MDBadge badgeContent={item.status} color={statusColor} variant="gradient" size="sm" />
        </MDBox>
      ),
      action: (
        <MDTypography
          component="a"
          href="#"
          variant="caption"
          color="text"
          fontWeight="medium"
          onClick={(e) => {
            e.preventDefault();
            onEdit(item.id);
          }}
        >
          {item.status === "Delivered" ? "View" : "Edit"}
        </MDTypography>
      ),
    };
  });

  return { columns, rows };
}
